import Vue from 'vue'
import * as Sentry from '@sentry/browser'
import { Vue as VueIntegration } from '@sentry/integrations'

Sentry.init({
  dsn: process.env.VUE_APP_SENTRY_DSN,
  environment: process.env.APP_ENV,
  integrations: [
    new VueIntegration({
      Vue,
      attachProps: true,
      logErrors: !(process.env.NODE_ENV === 'production')
    })
  ],
  attachStacktrace: true,
  ignoreErrors: ['ResizeObserver loop limit exceeded'],
  beforeSend: event => {
    // Check if it is an exception, and if so, show the report dialog
    if (event.exception && process.env.NODE_ENV === 'production') {
      Sentry.showReportDialog({ eventId: event.event_id })
    }
    return event
  }
})
